import Chart from 'react-apexcharts';

export const BankBalanceTrend = ({ bankSnapshots }) => {

    const rehydrateToTimeline = (bankSnapshots, intervalMinutes = 120) => {

        const output = [];
        for (const companyDataSet of Object.entries(bankSnapshots)) {

            for (const { range, balance } of companyDataSet[1]) {
                let current = new Date(range.start);
                const end = new Date(range.end);

                while (current <= end) {
                    output.push({
                        timeStamp: new Date(current), // preserve as full Date object if needed
                        balance: balance
                    });
                    current.setMinutes(current.getMinutes() + intervalMinutes);
                }
            }
        }

        return output;
    };

    const fullSeries = !!bankSnapshots ? rehydrateToTimeline(bankSnapshots) : [];
    
    // Filter to last 3 months
    const threeMonthsAgo = new Date();
    threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);
    const chartData = fullSeries.filter(item => new Date(item.timeStamp) >= threeMonthsAgo);

    const chartSettings = {
        series: [{
            name: 'Balance',
            data: chartData.map(item => item.balance)
        }],
        options: {
            chart: {
                type: 'line',
                height: 140,
                sparkline: { enabled: false },
                toolbar: { show: false }
            },
            xaxis: {
                labels: {
                    show: false
                },
                axisBorder: {
                    show: false
                },
                axisTicks: {
                    show: false
                }
            },
            stroke: {
                curve: 'smooth',
                width: 3
            },
            colors: ['#00d4aa'],
            markers: {
                size: 0
            },
            grid: {
                show: true,
                borderColor: 'rgba(255,255,255,0.1)',
                strokeDashArray: 3,
                padding: {
                    left: 20,
                    top: 5,
                    bottom: 10
                }
            },
            yaxis: {
                labels: {
                    style: {
                        colors: ['#ffffff']
                    },
                    formatter: (val) => `£${val?.toFixed(0) || '0'}`
                }
            },
            tooltip: {
                theme: 'dark',
                x: {
                    formatter: (val, opts) => {
                        const dataIndex = opts.dataPointIndex;
                        const item = chartData[dataIndex];
                        return item?.timeStamp ? new Date(item.timeStamp).toLocaleString() : '';
                    }
                },
                y: {
                    formatter: (val) => `£${val?.toFixed(2) || '0.00'}`
                }
            }
        }
    };

        return (
        <div className="card border-0 bg-gray-800 text-white" style={{ minHeight: '195px', maxHeight: '195px', overflow: 'hidden' }}>
            <div className="card-body">
                <div className="text-gray-500 mb-3">
                    <b>TREND</b>
                </div>
                <div className="text-white mb-0" style={{ height: '140px', overflow: 'hidden' }}>
                    {chartData.length > 0 ? (
                        <Chart
                            options={chartSettings.options}
                            series={chartSettings.series}
                            type="line"
							height={140}
                        />
                    ) : (
                        <p>No trend data available</p>
                    )}
                </div>
            </div>
        </div>
    );
};